var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1956,
    height: 1033,
    viewBox: "0 0 1956 1033",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1956,
    height: 1033,
    fill: "#171E44"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 899.453,
    y: 136.005,
    width: 802.227,
    height: 112.829,
    transform: "rotate(30 899.453 136.005)",
    fill: "white",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1067.25,
    y: 55,
    width: 802.227,
    height: 112.829,
    transform: "rotate(30 1067.25 55)",
    fill: "white",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 846.414,
    y: 304.766,
    width: 802.227,
    height: 112.829,
    transform: "rotate(30 846.414 304.766)",
    fill: "white",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 19.389,
    height: 23.934,
    rx: 2.36644,
    transform: "matrix(0.90133 -0.433133 -0.26576 -0.964039 191.528 126.163)",
    fill: "#FCFCFD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 19.389,
    height: 23.934,
    rx: 2.36644,
    transform: "matrix(0.90133 -0.433133 -0.26576 -0.964039 1856.73 251.844)",
    fill: "#FCFCFD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 14.0614,
    height: 17.3576,
    rx: 7.03072,
    transform: "matrix(0.90133 -0.433133 -0.26576 -0.964039 312.356 954.246)",
    fill: "#FCDA67"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 19.389,
    height: 23.934,
    rx: 2.36644,
    transform: "matrix(0.90133 -0.433133 -0.26576 -0.964039 1833.26 880.253)",
    fill: "#FCFCFD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 9.01646,
    height: 11.13,
    rx: 2.36644,
    transform: "matrix(0.90133 -0.433133 -0.26576 -0.964039 922.277 407.175)",
    fill: "#FCFCFD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 12.8687,
    height: 15.8853,
    rx: 6.43436,
    transform: "matrix(0.90133 -0.433133 -0.26576 -0.964039 1018.73 910.989)",
    fill: "#F6BFC9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 14.7029,
    height: 18.1494,
    rx: 7.35144,
    transform: "matrix(0.90133 -0.433133 -0.26576 -0.964039 701.16 178.815)",
    fill: "#B8DDB6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 20.6986,
    height: 25.5506,
    rx: 8,
    transform: "matrix(0.90133 -0.433133 -0.26576 -0.964039 1521.13 93.8555)",
    fill: "#FCDA67"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.e51789ffbdddf5fe5ee64ac517f1d9f8.svg";
export { ForwardRef as ReactComponent };